import { INITIAL_COLUMNS_STATE } from 'contexts/LandedCost/WinnersFiltersContext';
import {
	COLUMNS_TO_FILTER,
	INITIAL_OPERATOR_STATE,
	OPERATOR_TO_FILTER,
} from '../DailyCost/utils/columnsToFilter';

export const landedCostStoreSlice = (set) => ({
	landedCostColumns: COLUMNS_TO_FILTER,
	landedCostSearch: '',
	selectedDateFrom: null,
	selectedDateTo: null,
	operator: INITIAL_OPERATOR_STATE,
	operatorList: OPERATOR_TO_FILTER,
	landedCostSelectedBrand: null,
	paginationModel: {
		page: 0,
		pageSize: 10,
	},
	WinnersSearch: '',
	WinnersSelectedBrand: null,
	WinnersPaginationModel: { page: 0, pageSize: 10 },

	toggleLandedCostColumns: (column) =>
		set((state) => {
			const prevCols = { ...state.landedCostColumns };
			prevCols[column.data] = !prevCols[column.data];
			return {
				landedCostColumns: prevCols,
			};
		}),
	resetLandedCostColumns: () =>
		set(() => ({
			landedCostColumns: INITIAL_COLUMNS_STATE,
		})),
	setLandedCostSearch: (search) => set(() => ({ landedCostSearch: search })),
	setDateFrom: (dateString) => {
		set(() => ({ selectedDateFrom: dateString }));
	},
	clearSelectedDateFrom: () =>
		set(() => ({
			selectedDateFrom: null,
		})),
	setDateTo: (dateString) => {
		set(() => ({ selectedDateTo: dateString }));
	},
	clearSelectedDateTo: () =>
		set(() => ({
			selectedDateTo: null,
		})),
	toggleOperator: (operator) =>
		set((state) => {
			if (!operator?.name) return {};

			const prevOperator = { ...state.operator };
			prevOperator[operator.name] = !prevOperator[operator.name];
			return {
				operator: prevOperator,
			};
		}),

	setlandedCostSelectedBrand: (brand) =>
		set(() => ({
			landedCostSelectedBrand: brand,
		})),
	resetlandedCostSelectedBrand: () =>
		set(() => ({ landedCostSelectedBrand: null })),

	clearFilters: () =>
		set(() => ({
			landedCostSearch: '',
			selectedDateTo: null,
			selectedDateFrom: null,
			landedCostSelectedBrand: null,
		})),
	setPaginationModel: (model) => set({ paginationModel: model }),
	setWinnersSearch: (search) => set(() => ({ WinnersSearch: search })),
	setWinnersSelectedBrand: (brand) =>
		set(() => ({
			WinnersSelectedBrand: brand,
		})),
	resetWinnersSelectedBrand: () => set(() => ({ WinnersSelectedBrand: null })),
	winnersClearFilters: () =>
		set(() => ({
			WinnersSearch: '',
			WinnersSelectedBrand: null,
		})),
	setWinnersPaginationModel: (model) => set({ WinnersPaginationModel: model }),
});
